<template>
  <mdb-card>
    <mdb-card-header class="text-right entity-card-header p-1">
      <a v-if="order.requests.length > 1" @click="onMoveClicked()">
        <mdb-icon icon="copy" title="Move this request to new order"/>
      </a>
      <a @click="onCloneClicked()">
        <mdb-icon icon="clone" title="Clone this request"/>
      </a>
    </mdb-card-header>
    <mdb-card-body class="px-3 pb-2 entity-card-body">
      <ul class="list-unstyled">
        <li class="mb-1 d-flex justify-content-between">
          <mdb-icon icon="route" class="mr-2"/><span>{{ route }}</span>
        </li>
        <li class="mb-1 d-flex justify-content-between">
          <mdb-icon icon="clock" class="mr-2"/><span :title="created.full">{{ created.date }}</span>
        </li>
        <li class="mb-1 d-flex justify-content-between">
          <mdb-icon icon="box-open" class="mr-2"/>{{ getCargoInfo(request.cargo) }}
        </li>
      </ul>
    </mdb-card-body>
  </mdb-card>
</template>

<script>
import {
  mdbIcon,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
  mdbView
} from 'mdbvue'
import {OrderTypes} from '../enums'
import {cargoInfo, errorCatch, formatD, formatDT, orderType} from '../utils'
import {mapActions} from 'vuex'

export default {
  name: 'OrderRequest',
  props: {
    context: {
      validator: context => Object.values(OrderTypes).includes(context)
    },
    request: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    route: function () {
      if (this.request.origin && this.request.destination) {
        return `${this.request.origin.name} - ${this.request.destination.name}`
      }
      return 'n/a'
    },
    created: function () {
      return { full: formatDT(this.request.created), date: formatD(this.request.created) }
    }
  },
  methods: {
    ...mapActions('calc', ['setLinked', 'setClone']),
    ...mapActions(['apiOrderMoveRequest']),
    getCargoInfo (cargo) {
      return cargoInfo(cargo)
    },
    onCloneClicked () {
      this.$router.push('/calc')
        .then(() => {
          this.$bus.$emit(
            'clone-request',
            {
              request: this.request,
              type: orderType(this.order),
              context: this.context,
              order: orderType(this.order) === this.context ? this.order : null
            }
          )
        })
    },
    onMoveClicked () {
      this.apiOrderMoveRequest({
        type: orderType(this.order),
        orderUuid: this.order.info.uuid,
        requestUuid: this.request.uuid
      })
        .then(uuid => { this.$router.push({name: 'order', params: {uuid: uuid}}) })
        .catch(errorCatch('Move Request to new Order failed!', this))
    }
  },
  components: {
    mdbIcon,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    mdbView
  }
}
</script>

<style lang="sass" scoped>
.entity-card-header
  font-size: 75%

.entity-card-body
  font-size: 75%
</style>



// WEBPACK FOOTER //
// src/components/OrderRequest.vue